export enum RequestStatusTypeEnum {
  Medication = 1,
  LabTests
}
